import { DEFAULT_CONTENT_TAGS } from 'shared/constants';
import { useEffect, useState } from 'react';
import organizationServiceApi from 'shared/api/organization.service.api';
import _ from 'lodash';

/**
 * Get suggested keywords and functions to update, reset and search keywords
 * @param {Object} { keywords } - knowledge item keywords or empty array
 * @returns {Object} { suggestedKeywords, newKeywords, updateKeywords, resetKeywords, searchKeywords, searchValue }
 */
export const useKeywords = ({ keywords = [] }) => {
  const [organizationKeywords, setOrganizationKeywords] = useState([]);
  const [filteredKeywords, setFilteredKeywords] = useState([]);
  const [newKeywords, setNewKeywords] = useState([]);
  const [search, setSearch] = useState('');

  const fetchKeywords = async () => {
    const { data } = await organizationServiceApi.getKeywords();
    setOrganizationKeywords(_.uniq([...data.keywords, ...DEFAULT_CONTENT_TAGS]));
  };

  useEffect(() => {
    fetchKeywords();
  }, []);

  useEffect(() => {
    const suggestedKeywords = organizationKeywords
      .filter(word => !keywords.includes(word))
      .filter(word => !newKeywords.includes(word))
      .filter(word => search === '' || word.toLowerCase().includes(search.toLowerCase()));

    setFilteredKeywords(suggestedKeywords);
  }, [newKeywords, keywords, search, organizationKeywords]);

  const updateKeywords = words => {
    setNewKeywords(_.uniq([...words]));
    setSearch('');
  };

  const resetKeywords = () => setNewKeywords([]);

  const searchKeywords = value => {
    setSearch(value);
  };

  return {
    suggestedKeywords: filteredKeywords,
    newKeywords,
    updateKeywords,
    resetKeywords,
    searchKeywords,
    searchValue: search,
  };
};
